import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const AirportName = styled.div`
  font-size: 28px;
  margin-bottom: 4px;
`;
const FlightTime = styled.div`
  font-size: 14px;
`;

export default function AirportNameAndFlightTime({ airportName, flightTime }) {
  return (
    <Container>
      <AirportName>{airportName}</AirportName>
      <FlightTime>{flightTime}</FlightTime>
    </Container>
  )
}
